import React, { Component } from 'react';
import {
	Cotainer,
	InfoSection,
	MainSection
} from '../../components/AppWrapper';
import { HOLLAEX_KIT, RUNNING_MESSAGE } from '../../config/constants';
import {
	LOGO_HOLLAEX,
	EXCHANGE_CARD_ICON_BLACK,
	ICON_BOX,
	ICON_WALLET,
	ICON_SEARCH,
	ICON_KEY,
	XHT_ICON_WHITE,
	ICON_BILLING
} from '../../config/media';
import { Button, Select, Icon, message, Modal } from 'antd';
import Wrapper from './style';
import ExchangeListBar from '../../components/ExchangeListBar';
import ExchangeInfo from './ExchangeInfo';
import Collateral from '../ExchangeCollateral';
import ExchangeMember from '../ExchangeMember';
import ExchangeBilling from '../ExchangeBilling';
import { deleteExchange } from '../../common/fetch';
import { generateFiles } from '../../common/utils';

const { Option } = Select;

class Exchange extends Component {
	state = {
		isHide: true,
		mobileToggle: false
	};

	componentDidMount() {
		if (this.props.data.length) {
			if (this.props.data[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.data[0].id}`);
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)
			&& this.props.data.length
		) {
			if (this.props.data[0].is_completed) {
				this.props.history.push('/dashboard');
			} else {
				this.props.history.push(`/exchange/setup?id=${this.props.data[0].id}`);
			}
		}
	}

	componentWillReceiveProps() {
		if (window.innerWidth < 1200 && this.state.mobileToggle) {
			this.setState({
				mobileToggle: false
			});
		}
	}

	goToSetup = () => {
		const { history, location, data } = this.props;
		let exchange = data[0];
		if (exchange.is_running) {
			message.info(RUNNING_MESSAGE);
			return;
		}
		let url = '/exchange/setup' + location.search;
		if (location.search === '') {
			url += `?id=${exchange.id}`;
		}

		history.push(url);
	};

	download = () => {
		const { data, location } = this.props;
		let exchange = {};
		if (location.search === '') {
			exchange = data[0];
		} else {
			const search = location.search.split('=');
			exchange = data.filter((item) => {
				return item.id === parseInt(search[1]);
			})[0];
		}
		generateFiles(exchange);
	};

	confirmDelete = () => {
		Modal.confirm({
			title: 'Are you sure you want to delete your exchange?',
			content:
				'You are about to permanently delete your exchange. Please keep in mind that this action is not reversible.',
			onOk: () => {
				this.onDelete();
			},
			onCancel: () => { }
		});
	};

	onDelete = async () => {
		const { location, data } = this.props;
		let exchange = data[0];

		const body = {
			id: 0
		};
		if (location.search === '') {
			body.id = parseInt(exchange.id);
		} else {
			const search = location.search.split('=');
			body.id = parseInt(search[1]);
		}
		try {
			await deleteExchange(body);
			const newData = data.filter((item) => {
				return body.id !== parseInt(item.id);
			});
			message.success('Success to delete the exchange');
			this.props.history.replace('/exchange');
			this.props.actions.readData(newData);
		} catch (error) {
			console.error(error);
			message.warning(error.data && error.data.message);
		}
	};

	renderSideBar = () => {
		const { data, location, history } = this.props;
		const OptionImgProps = {
			height: '15px',
			verticalAlign: 'middle',
			marginRight: '8px'
		};
		if (data.length === 0) {
			return (
				<div>
					<img
						src={LOGO_HOLLAEX}
						alt="LOGO_HOLLAEX"
						className="info-logo"
					/>
					<h3>
						<b>HollaEx Exchange Kit</b>
					</h3>
					<p>
						Create new marketplaces and business opportunities with the
						HollaEx Kit. The Kit includes a pro trading interface, broker
						quick trading and is fully customizable.
					</p>
					<Button
						block
						type="primary"
						onClick={() => {
							if (window.innerWidth < 1200) {
								this.setState({ mobileToggle: false });
							}
							history.push('/exchange/new');
						}}
					>
						<img src={ICON_WALLET} alt="icon" />
						Create Exchange
					</Button>
					<Button block type="primary">
						<a
							href={HOLLAEX_KIT}
							download="hollaex-kit.zip"
							rel="noopener noreferrer"
							onClick={() => {
								if (window.innerWidth < 1200) {
									this.setState({ mobileToggle: false });
								}
							}}
						>
							<img src={ICON_BOX} alt="icon" />
							Download Kit
						</a>
					</Button>
					<Button block type="primary">
						<a
							href="https://docs.hollaex.com/"
							target="_blank"
							rel="noopener noreferrer"
							onClick={() => {
								if (window.innerWidth < 1200) {
									this.setState({ mobileToggle: false });
								}
							}}
						>
							<img src={ICON_SEARCH} alt="icon" />
							Documentation
						</a>
					</Button>
					<Select defaultValue="Create Exchange">
						<Option
							value="Create Exchange"
							block
							type="primary"
							onClick={() => {
								if (window.innerWidth < 1200) {
									this.setState({ mobileToggle: false });
								}
								history.push('/exchange/new');
							}}
						>
							<img style={OptionImgProps} src={ICON_WALLET} alt="icon" />
							Create Exchange
						</Option>
						<Option value="Download Kit" block type="primary">
							<a
								href={HOLLAEX_KIT}
								download="hollaex-kit.zip"
								rel="noopener noreferrer"
								onClick={() => {
									if (window.innerWidth < 1200) {
										this.setState({ mobileToggle: false });
									}
								}}
							>
								<img style={OptionImgProps} src={ICON_BOX} alt="icon" />
								Download Kit
							</a>
						</Option>
						<Option value="Documentation" block type="primary">
							<a
								href="https://docs.hollaex.com/"
								target="_blank"
								rel="noopener noreferrer"
								onClick={() => {
									if (window.innerWidth < 1200) {
										this.setState({ mobileToggle: false });
									}
								}}
							>
								<img
									style={OptionImgProps}
									src={ICON_SEARCH}
									alt="icon"
								/>
								Documentation
							</a>
						</Option>
					</Select>
				</div>
			);
		}
		let exchange = data[0] || {};
		if (location.search !== '') {
			const id = location.search.split('=')[1];
			exchange = data.filter((item) => {
				return item.id === parseInt(id, 10);
			});
			exchange = exchange[0] || {};
		}

		const imgIndex = (exchange.id % 6) + 1;
		return (
			<div>
				<img
					src={EXCHANGE_CARD_ICON_BLACK[imgIndex]}
					alt="LOGO_HOLLAEX"
					className="info-logo"
				/>
				<h3>
					<b>{exchange.name}</b>
					<br />
					<span className="url">{exchange.url}</span>
				</h3>
				<p>
					To run your exchange you must first complete the create exchange
					setup, then download the kit and follow the documentation.
				</p>
				<Button block type="primary" onClick={this.goToSetup}>
					<img src={ICON_WALLET} alt="icon" />
					Exchange Setup
				</Button>
				<Button
					block
					type="primary"
					onClick={() => {
						const url = '/billing' + location.search;
						this.props.history.push(url);
					}}
				>
					<img src={ICON_BILLING} alt="icon" />
						Billing
				</Button>
				<Button block type="primary">
					<a
						href={HOLLAEX_KIT}
						download="hollaex-kit.zip"
						rel="noopener noreferrer"
					>
						<img src={ICON_BOX} alt="icon" />
						Download Kit
					</a>
				</Button>
				<Button block type="primary">
					<a
						href="https://docs.hollaex.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img src={ICON_SEARCH} alt="icon" />
						Documentation
					</a>
				</Button>
				<Button
					block
					type="primary"
					onClick={() => {
						const url = '/collateral' + location.search;
						this.props.history.push(url);
					}}
				>
					<img src={XHT_ICON_WHITE} alt="icon" />
					Collateralize
				</Button>
				<Button
					block
					type="primary"
					onClick={() => {
						const url = '/exchange/member' + location.search;
						this.props.history.push(url);
					}}
				>
					<Icon type="usergroup-add" style={{ fontSize: '12px' }} />
					Member
				</Button>
				<Button type="danger" onClick={this.confirmDelete}>
					<Icon type="delete" style={{ fontSize: '12px' }} />
					Delete Exchange
				</Button>

				<Select defaultValue="Exchange Setup">
					<Option
						value="Exchange Setup"
						block
						type="primary"
						onClick={this.goToSetup}
					>
						<img style={OptionImgProps} src={ICON_WALLET} alt="icon" />
						Exchange Setup
					</Option>
					<Option value="Download Kit" block type="primary">
						<a
							href={HOLLAEX_KIT}
							download="hollaex-kit.zip"
							rel="noopener noreferrer"
						>
							<img style={OptionImgProps} src={ICON_BOX} alt="icon" />
							Download Kit
						</a>
					</Option>
					<Option value="Documentation" block type="primary">
						<a
							href="https://docs.hollaex.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img style={OptionImgProps} src={ICON_SEARCH} alt="icon" />
							Documentation
						</a>
					</Option>
					{exchange.is_public && (
						<Option
							block
							value="Documentation"
							onClick={() => {
								const url = '/project/' + exchange.id;
								this.props.history.push(url);
							}}
							type="primary"
						>
							<img src={ICON_KEY} alt="icon" style={OptionImgProps} />
							Pitch Exchange
						</Option>
					)}
					<Option
						value="Collateralize"
						block
						type="primary"
						onClick={() => {
							const url = '/collateral' + location.search;
							this.props.history.push(url);
						}}
					>
						<img style={OptionImgProps} src={XHT_ICON_WHITE} alt="icon" />
						Collateralize
					</Option>
					<Option
						value="Delete Exchange"
						block
						type="danger"
						onClick={this.onDelete}
					>
						<Icon type="delete" style={{ fontSize: '12px' }} />
						Delete Exchange
					</Option>
				</Select>
			</div>
		);
	};

	renderBody = () => {
		const { data, location, history } = this.props;
		if (location.pathname.indexOf('collateral') >= 0) {
			return <Collateral location={location} history={history} />;
		}
		if (location.pathname.indexOf('member') >= 0) {
			return <ExchangeMember location={location} history={history} />;
		}
		if (location.pathname.indexOf('billing/paid') >= 0) {
			return <ExchangeBilling activeTab={'2'} location={location} history={history} />;
		}
		if (location.pathname.indexOf('billing') >= 0) {
			return <ExchangeBilling activeTab={'1'} location={location} history={history} />;
		}
		return (
			<ExchangeInfo
				data={data}
				location={location}
				history={history}
				goToSetup={this.goToSetup}
				download={this.download}
			/>
		);
	};

	render() {
		const { mobileToggle } = this.state;
		const { data } = this.props;
		let className = '';
		if (data.length === 0) {
			className = 'isNew';
		}

		return (
			<Cotainer>
				<ExchangeListBar />
				<InfoSection className={mobileToggle ? 'on exchange' : 'exchange'}>
					{this.renderSideBar()}
				</InfoSection>
				<MainSection>
					<Wrapper className={className}>{this.renderBody()}</Wrapper>
				</MainSection>
			</Cotainer>
		);
	}
}

export default Exchange;
